/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const GET_CURRENT_USER_REQUEST = 'GET_CURRENT_USER_REQUEST';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE';

export const GET_CURRENT_USER_RESOURCES_REQUEST = 'GET_CURRENT_USER_RESOURCES_REQUEST';
export const GET_CURRENT_USER_RESOURCES_SUCCESS = 'GET_CURRENT_USER_RESOURCES_SUCCESS';
export const GET_CURRENT_USER_RESOURCES_FAILURE = 'GET_CURRENT_USER_RESOURCES_FAILURE';

export const LOGOUT_CURRENT_USER_REQUEST = 'LOGOUT_CURRENT_USER_REQUEST';
export const LOGOUT_CURRENT_USER_SUCCESS = 'LOGOUT_CURRENT_USER_SUCCESS';
export const LOGOUT_CURRENT_USER_FAILURE = 'LOGOUT_CURRENT_USER_FAILURE';

export const LOAD_ANNOUNCEMENTS_REQUEST = 'LOAD_ANNOUNCEMENTS_REQUEST';
export const LOAD_ANNOUNCEMENTS_SUCCESS = 'LOAD_ANNOUNCEMENTS_SUCCESS';
export const LOAD_ANNOUNCEMENTS_FAILURE = 'LOAD_ANNOUNCEMENTS_FAILURE';

// Server related
export const GET_SERVER_CONFIGURATION = 'GET_SERVER_CONFIGURATION';
export const GET_SERVER_CONFIGURATION_SUCCESS = 'GET_SERVER_CONFIGURATION_SUCCESS';
export const GET_SERVER_CONFIGURATION_FAILURE = 'GET_SERVER_CONFIGURATION_FAILURE';

// Tenant related
export const SET_TENANT = 'SET_TENANT';
export const UPDATE_TENANT = 'UPDATE_TENANT';
export const GET_TENANT_ACTIVE_SERVICES = 'GET_TENANT_ACTIVE_SERVICES';
export const GET_TENANT_ACTIVE_SERVICES_SUCCESS = 'GET_TENANT_ACTIVE_SERVICES_SUCCESS';
export const GET_TENANT_ACTIVE_SERVICES_FAILURE = 'GET_TENANT_ACTIVE_SERVICES_FAILURE';

// Get the tenants related to an email adress
export const GET_TENANTS_RELATED_TO_USER_REQUEST = 'GET_TENANTS_RELATED_TO_USER_REQUEST';
export const GET_TENANTS_RELATED_TO_USER_SUCCESS = 'GET_TENANTS_RELATED_TO_USER_SUCCESS';
export const GET_TENANTS_RELATED_TO_USER_FAILURE = 'GET_TENANTS_RELATED_TO_USER_FAILURE';
